module.exports = __webpack_public_path__ + "static/media/ic-map-marker.76eddd3d.svg";